import apiClient from '../apiClient';

export const getUserPermissions = () => {
  return apiClient.get('/auth/permissions');
};

export const getAllPermissions = () => {
  return apiClient.get('/permissions');
};